import type { FC } from 'react'

import { Button } from '@skytech/ui/Button'
import { useNavigate } from 'react-router-dom'

import { Translation } from '@/components/i18n/Translation'

import { Asset } from '../end-of-lease/Asset'
import { myAssets } from '../mock'

export const ReturnDevice: FC = () => {
  const navigate = useNavigate()

  const oldAsset = myAssets[0]

  return (
    <div className="rounded-lg bg-white p-4">
      <h1 className="mb-4 text-2xl">
        <Translation id="Return Device" />
      </h1>

      <p className="text-lg">
        <Translation id="Please return the below device to the IT Manager" />
      </p>
      <Asset
        alias={oldAsset.alias}
        currency={oldAsset.currency}
        id={oldAsset.id}
        imgUrl={oldAsset.imgUrl}
        name={oldAsset.name}
        price={oldAsset.price}
        isMine
      />

      <p className="text-lg">
        <Translation id="Or ship it to this address:" />
      </p>
      <div className="text-lg">
        <Translation id="Mäster Samuelsgatan 60" />
      </div>
      <div className="text-md">
        <Translation id="111 21 , Stockholm" />
      </div>

      <p className="text-lg">
        <Translation id="Please make sure to return the device within 14 days" />
      </p>

      <div className="mt-4">
        <Button variant="primary" onClick={() => navigate('/activities')}>
          <Translation id="Return Device" />
        </Button>
      </div>
    </div>
  )
}
